module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "title-block"
  }, [_c('h1', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781847675651_booktitlepage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/9781847675651_introduction"
    }
  }, [_vm._v("Introduction")]), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/9781847675651_part_01"
    }
  }, [_vm._v("Book One: Wahn, Wahn, überall Wahn …")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/9781847675651_chapter_01"
    }
  }, [_vm._v("Chapter One")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/9781847675651_chapter_02"
    }
  }, [_vm._v("Chapter Two")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781847675651_chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781847675651_chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781847675651_chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781847675651_chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781847675651_part_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Two: Was gilt’s, Was Ich Dir Sagen Kann? …")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781847675651_chapter_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter One")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781847675651_chapter_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781847675651_chapter_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781847675651_chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781847675651_chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781847675651_chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781847675651_abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/9781847675651_insertedcopyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04505586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847675651_toc.vue
// module id = 63
// module chunks = 0